"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Translations = exports.Lang = exports.MAX_RESULT_PER_PAGE = void 0;
exports.MAX_RESULT_PER_PAGE = 6;
exports.Lang = {
    en: 'English',
    it: 'Italiano',
    de: 'Deutsch',
    es: 'Español',
    fr: 'Français',
    pt: 'Português',
    ja: '日本語',
    ko: '한국어',
};
exports.Translations = {
    en: {
        'translation': {
            'content-type': 'Content Type',
            'file-type': 'File Type',
            'site': 'Site',
            'language': 'Language',
            'Sort by Relevance': 'Sort by Relevance',
            'Sort by Most Recent': 'Sort by Most Recent',
            'Size': 'Size: ',
            'Updated': 'Updated: ',
            'Site': 'Site: ',
            'login-message': 'This result may require a log in with a myrotary account.',
        },
        'caption-rotary_sitename': {
            'Convention': 'Convention',
            'Brand Center': 'Brand Center',
            'End Polio': 'End Polio',
            'My Rotary': 'My Rotary',
            'Rotary.org': 'Rotary.org',
        },
        'caption-rotary_contenttype': {
            'Content Page': 'Content Page',
            'Document': 'Document',
        },
        'caption-rotary_filetype': {
            Presentation: 'Presentation',
            SpreadSheet: 'Spreadsheet',
            PDF: 'PDF',
            Text: 'Text',
            Zip: 'Zip',
        },
    },
    de: {
        'translation': {
            'content-type': 'Inhaltsart',
            'file-type': 'Dateityp',
            'site': 'Site',
            'language': 'Sprache',
            'Sort by Relevance': 'Sortieren nach Relevanz',
            'Sort by Most Recent': 'Sortieren nach Aktualität',
            'Updated': 'Aktualisierte Version: ',
            'Size': 'Größe: ',
            'Site': 'Website: ',
            'login-message': 'Für ein Suchresultat ist möglicherweise eine Anmeldung über ein Mein-Rotary-Konto erforderlich.',
        },
        'caption-rotary_sitename': {
            'Convention': 'Convention (Jahreskongress)',
            'Brand Center': 'Brand-Center',
            'End Polio': 'END POLIO',
            'My Rotary': 'Mein Rotary',
            'Rotary.org': 'Rotary.org',
        },
        'caption-rotary_contenttype': {
            'Content Page': 'Inhaltsseite',
            'Document': 'Dokument',
        },
        'caption-rotary_filetype': {
            Presentation: 'Präsentation',
            SpreadSheet: 'Tabellenkalkulation (Spreadsheet)',
            PDF: 'PDF',
            Text: 'Text',
            Zip: 'Zip',
        },
    },
    es: {
        'translation': {
            'content-type': 'Tipo de contenido',
            'file-type': 'Tipo de archivo',
            'site': 'Sitio web',
            'language': 'Idioma',
            'Sort by Relevance': 'Ordenar por relevancia',
            'Sort by Most Recent': 'Ordenar por más reciente',
            'Updated': 'Actualizado el: ',
            'Size': 'Tamaño: ',
            'Site': 'Sitio web: ',
            'login-message': 'Este resultado podría requerir iniciar sesión con una cuenta en Mi Rotary.',
        },
        'caption-rotary_sitename': {
            'Convention': 'Convención',
            'Brand Center': 'Brand Center',
            'End Polio': 'Pongamos Fin a la Polio',
            'My Rotary': 'Mi Rotary',
            'Rotary.org': 'Rotary.org',
        },
        'caption-rotary_contenttype': {
            'Content Page': 'Página de contenidos',
            'Document': 'Documento',
        },
        'caption-rotary_filetype': {
            Presentation: 'Presentación',
            SpreadSheet: 'Hoja de cálculo',
            PDF: 'PDF',
            Text: 'Texto',
            Zip: 'Zip',
        },
    },
    fr: {
        'translation': {
            'content-type': 'Type de contenu',
            'file-type': 'Type de fichier',
            'site': 'Site',
            'language': 'Langue',
            'Sort by Relevance': 'Trier par pertinence',
            'Sort by Most Recent': 'Trier par le plus récent',
            'Updated': 'Mis à jour le ',
            'Size': 'Taille: ',
            'Site': 'Site: ',
            'login-message': 'Ce résultat peut nécessiter une connexion à un compte Mon Rotary.',
        },
        'caption-rotary_sitename': {
            'Convention': 'Convention',
            'Brand Center': 'Brand Center',
            'End Polio': 'End Polio',
            'My Rotary': 'Mon Rotary',
            'Rotary.org': 'Rotary.org/fr',
        },
        'caption-rotary_contenttype': {
            'Content Page': 'Page',
            'Document': 'Document',
        },
        'caption-rotary_filetype': {
            Presentation: 'Présentation',
            SpreadSheet: 'Feuille de calcul',
            PDF: 'PDF',
            Text: 'Texte',
            Zip: '.Zip',
        },
    },
    it: {
        'translation': {
            'content-type': 'Tipo di contenuto',
            'file-type': 'Tipo di file',
            'site': 'Sito',
            'language': 'Lingua',
            'Sort by Relevance': 'Ordina per rilevanza',
            'Sort by Most Recent': 'Ordina per più recente',
            'Updated': 'Aggiornato il: ',
            'Size': 'Dimensioni: ',
            'Site': 'Sito: ',
            'login-message': 'Questo risultato potrebbe richiedere l’accesso per l’account de Il mio Rotary.',
        },
        'caption-rotary_sitename': {
            'Convention': 'Convention',
            'Brand Center': 'Brand Center',
            'End Polio': 'End Polio',
            'My Rotary': 'Il mio Rotary',
            'Rotary.org': 'Rotary.org',
        },
        'caption-rotary_contenttype': {
            'Content Page': 'Pagina di contenuto',
            'Document': 'Documento',
        },
        'caption-rotary_filetype': {
            Presentation: 'Presentazione',
            SpreadSheet: 'Foglio di calcolo',
            PDF: 'PDF',
            Text: 'Testo',
            Zip: 'Zip',
        },
    },
    ja: {
        'translation': {
            'content-type': 'コンテンツの種類',
            'file-type': 'ファイルの種類',
            'site': 'サイト',
            'language': '使用言語',
            'Sort by Relevance': '関連性で並べ替え',
            'Sort by Most Recent': '新しい順で並べ替え',
            'Updated': '更新日：',
            'Size': 'サイズ：',
            'Site': 'サイト：',
            'login-message': 'この検索結果の内容をご覧いただくには、My ROTARYへのログインが必要となる場合があります。',
        },
        'caption-rotary_sitename': {
            'Convention': '国際大会',
            'Brand Center': 'ブランドリソースセンター',
            'End Polio': 'ポリオ根絶',
            'My Rotary': 'My ROTARY',
            'Rotary.org': 'Rotary.org',
        },
        'caption-rotary_contenttype': {
            'Content Page': 'ページ',
            'Document': '文書',
        },
        'caption-rotary_filetype': {
            Presentation: 'プレゼンテーション',
            SpreadSheet: 'スプレッドシート',
            PDF: 'PDF',
            Text: 'テキスト',
            Zip: 'Zip',
        },
    },
    ko: {
        'translation': {
            'content-type': '콘텐츠 유형',
            'file-type': '파일 유형',
            'site': '사이트',
            'language': '언어',
            'Sort by Relevance': '관련성 순으로 정렬',
            'Sort by Most Recent': '최신 순으로 정렬',
            'Updated': '업데이트: ',
            'Size': '사이즈: ',
            'Site': '사이트: ',
            'login-message': '이 결과는 내 로타리 계정에 로그인해야 얻을 수 있습니다.',
        },
        'caption-rotary_sitename': {
            'Convention': '세계대회',
            'Brand Center': '브랜드 센터',
            'End Polio': '소아마비 퇴치',
            'My Rotary': '내 로타리',
            'Rotary.org': 'Rotary.org',
        },
        'caption-rotary_contenttype': {
            'Content Page': '콘텐츠 페이지',
            'Document': '문서',
        },
        'caption-rotary_filetype': {
            Presentation: '프레젠테이션',
            SpreadSheet: '스프레드시트',
            PDF: 'PDF',
            Text: '텍스트',
            Zip: '압축파일(Zip)',
        },
    },
    pt: {
        'translation': {
            'content-type': 'Tipo de conteúdo',
            'file-type': 'Tipo de arquivo',
            'site': 'Site',
            'language': 'Idioma',
            'Sort by Relevance': 'Ordenar por relevância',
            'Sort by Most Recent': 'Ordenar por mais recente',
            'Updated': 'Atualizado em: ',
            'Size': 'Tamanho: ',
            'Site': 'Site: ',
            'login-message': 'Este resultado pode exigir login no Meu Rotary.',
        },
        'caption-rotary_sitename': {
            'Convention': 'Convenção',
            'Brand Center': 'Brand Center',
            'End Polio': 'End Polio',
            'My Rotary': 'Meu Rotary',
            'Rotary.org': 'Rotary.org',
        },
        'caption-rotary_contenttype': {
            'Content Page': 'Página',
            'Document': 'Documento',
        },
        'caption-rotary_filetype': {
            Presentation: 'Apresentação',
            SpreadSheet: 'Planilha',
            PDF: 'PDF',
            Text: 'Texto',
            Zip: 'Zip',
        },
    },
};
//# sourceMappingURL=constant.js.map